import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestUrlService, TypeUrl } from './settings/rest-url.service';
import { Observable } from 'rxjs';
import { IBanner } from '@interfaces';

@Injectable({
    providedIn: 'root'
})
export class BannersService {
    private readonly _url: string;

    constructor(
        private readonly http: HttpClient,
        private readonly urlRest: RestUrlService
    ) {
        this._url = 'https:' + this.urlRest.getUrl(TypeUrl.rest);
    }

    getBannersForMainPage(): Observable<{ additional: IBanner[], main: IBanner[] }> {
        return this.http.get<{ additional: IBanner[], main: IBanner[] }>(this._url + '/api/main/ad');
    }

}
